import { render, staticRenderFns } from "./ImageLibraryDialog.vue?vue&type=template&id=50534c8a&scoped=true&lang=pug&"
import script from "./ImageLibraryDialog.vue?vue&type=script&lang=js&"
export * from "./ImageLibraryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageLibraryDialog.vue?vue&type=style&index=0&id=50534c8a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50534c8a",
  null
  
)

/* custom blocks */
import block0 from "./ImageLibraryDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports